export default __webpack_public_path__ + "static/media/background_squares.28192eda.svg";